import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=e12849f0&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=e12849f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12849f0",
  null
  
)

export default component.exports